import React, { useState } from "react";
import { Card, Switch, Button } from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Select from "../Select";

export function VariablesHonorario({
  atributos,
  setAtributosValores,
  atributosValores,
  handleActualizar,
}) {
  return (
    <Card
      style={{
        padding: "1.8rem",
        backgroundColor: "#e6e6e6",
        color: "#3a506b",
      }}
    >
      <Grid container spacing={2}>
        {atributos?.inputs
          .sort((a, b) => a.pivot_orden_filtro - b.pivot_orden_filtro)
          .map((input) => {
            const commonProps = {
              key: input.id,
              item: true,
              xs: 12,
              sm: 6,
              md: 4,
              style: { display: "flex", alignItems: "center" },
            };

            const tieneAclaracion =
              input.aclaracion && input.aclaracion.trim() !== "";

            if (input.es_input === "s") {
              return (
                <Grid {...commonProps}>
                  <span
                    className="honorario_filtro_label"
                    style={{
                      marginRight: "8px",
                      cursor: tieneAclaracion ? "help" : "default",
                    }}
                  >
                    {input.nombre}:
                    {tieneAclaracion ? (
                      <span
                        className="tooltip-text"
                        dangerouslySetInnerHTML={{ __html: input.aclaracion }}
                      />
                    ) : (
                      <></>
                    )}
                  </span>
                  <TextFieldExtended
                    style={{ width: "5rem" }}
                    type="number"
                    setAtributos={(newValue) =>
                      setAtributosValores((s) => ({
                        ...s,
                        [input.id_a]: Number(newValue),
                      }))
                    }
                    defvalue={input.valor_default}
                    value={atributosValores[input.id_a]}
                    max={input.valor_maximo}
                    min={input.valor_minimo}
                  />
                </Grid>
              );
            }

            if (input.es_select === "s") {
              return (
                <Grid {...commonProps}>
                  <span
                    className="honorario_filtro_label"
                    style={{
                      marginRight: "8px",
                      cursor: tieneAclaracion ? "help" : "default",
                    }}
                  >
                    {input.nombre}:
                    {tieneAclaracion ? (
                      <span
                        className="tooltip-text"
                        dangerouslySetInnerHTML={{ __html: input.aclaracion }}
                      />
                    ) : (
                      <></>
                    )}
                  </span>
                  <Select
                    onChange={(e) =>
                      setAtributosValores((s) => ({
                        ...s,
                        [input.id_a]: e.target.value,
                      }))
                    }
                    opciones={input.opciones}
                    value={atributosValores[input.id_a]}
                  />
                </Grid>
              );
            }

            if (input.es_toggle === "s") {
              return (
                <Grid {...commonProps}>
                  <span
                    className="honorario_filtro_label"
                    style={{
                      marginRight: "8px",
                      cursor: tieneAclaracion ? "help" : "default",
                    }}
                  >
                    {input.nombre}:
                    {tieneAclaracion ? (
                      <span
                        className="tooltip-text"
                        dangerouslySetInnerHTML={{ __html: input.aclaracion }}
                      />
                    ) : (
                      <></>
                    )}
                  </span>
                  <Switch
                    onChange={(e) =>
                      setAtributosValores((s) => ({
                        ...s,
                        [input.id_a]: e.target.checked ? "s" : "n",
                      }))
                    }
                    checked={atributosValores[input.id_a] === "s"}
                  />
                </Grid>
              );
            }
            if (input.es_link === "s") {
              return (
                <Grid
                  {...commonProps}
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ fontSize: "0.8rem", padding: "0 16px" }}
                >
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    alt={input.aclaracion}
                    href={input.valor}
                  >
                    {input.nombre}
                  </a>
                </Grid>
              );
            }

            return null;
          })}
        <Grid
          item
          xs={12}
          md={4}
          style={{ display: "flex", alignItems: "center" }}
        >
          <Button
            onClick={handleActualizar}
            className="btn-orixia bg-green"
            style={{ color: "rgb(200, 249, 202)" }}
          >
            Actualizar
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
}

function TextFieldExtended(props) {
  const [value, setValue] = useState(props.defvalue ?? "");
  const [error, setError] = useState([false, ""]);
  const { min, max, setAtributos } = props;

  const handleBlur = (e) => {
    const newValue = e.target.value;

    if (min && Number(newValue) < min) {
      setValue(min);
      setAtributos(min);
      setError([true, `El valor mínimo permitido es ${min}`]);
      return;
    }
    if (max && Number(newValue) > max) {
      setValue(max);
      setAtributos(max);
      setError([true, `El valor máximo permitido es ${max}`]);
      return;
    } else {
      setAtributos(newValue);
    }
    return;
  };
  const display = "flex";
  return (
    <div style={{ position: "relative" }}>
      <TextField
        {...props}
        onChange={(e) =>{ 
          setError([false, ""]);
          setValue(e.target.value)}}
        onBlur={handleBlur}
        value={value}
        style={{ position: "relative" }}
      />
      {error[0] ? (
        <div
          style={{
            display,
            flexWrap:"nowrap",
            color: "red",
            fontSize: "0.8rem",
            position: "absolute",
            bottom:"-1.2rem",
            width: "600px",
          }}
        >{error[1]}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
